export enum StartEnd {
  START = 1,
  END = 2,
}

export default StartEnd
